import handyScroll from 'handy-scroll'
import 'handy-scroll/dist/handy-scroll.css'

import Vue from 'vue'

const handyScrollDirective = {

  // Mount on `inserted` (element is in the DOM), not `bind` (it is not yet):
  // mounting pre-insert makes handy-scroll measure zero overflow and hide.
  // Tables that re-key their root (bulk-select bumps refreshKey) rebuild the
  // element with no later re-render, so a hidden widget never recovered.
  inserted(el, binding, vnode, prevVnode) {
    handyScroll.mount(el);
    setTimeout(() => handyScroll.update(el), 0);
    setTimeout(() => handyScroll.update(el), 500);
  },
  componentUpdated(el, binding, vnode, prevVnode) {
    setTimeout(() => handyScroll.update(el), 500);
  },
  unbind(el, binding, vnode, prevVnode) {
      handyScroll.destroy(el);
  }
}

Vue.directive('handy-scroll', handyScrollDirective)
